import { ChangeDetectionStrategy, Component, inject} from '@angular/core';
import { AbstractFormComponent, FieldTextComponent, FieldNumberComponent, FieldTextAreaComponent, FieldDateComponent, FieldSelectComponent } from '@spike/scaffolds';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';
import { WalletListComponent } from "../../components/wallet-list/wallet-list";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-account-transfer-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CommonModule, FormsModule, FieldTextAreaComponent, FieldSelectComponent, FieldNumberComponent, FieldDateComponent, WalletListComponent],
  templateUrl: './account-transfer-form.html'
})

export class AccountTransferFormComponent extends AbstractFormComponent{
  public readonly walletStoreService = inject(WalletStoreService);
  

}
  

